<template>
  <!-- Confirmation Modal -->
  <Teleport to="body">
    <Transition name="fade">
      <div v-if="isOpen"
           class="fixed inset-0 bg-gray-800/50 z-50 flex items-center justify-center p-4"
           @click="handleBackdropClick">
        <!-- Modal Card -->
        <div class="w-full max-w-sm"
             @click.stop>
          <Transition name="scale-up">
            <div v-if="isOpen"
                 class="bg-card rounded-lg shadow-2xl border border-border overflow-hidden">
              <!-- Header -->
              <div v-if="title"
                   :class="[
                     'px-6 py-4 border-b border-border ',
                     isDangerous ? 'bg-red-50' : 'bg-gray-600',
                   ]">
                <h2 :class="['text-lg font-bold', isDangerous ? 'text-red-700' : 'text-foreground']">
                  {{ title }}
                </h2>
              </div>

              <!-- Content -->
              <div class="px-6 py-4">
                <p :class="['text-foreground', isDangerous ? 'text-red-600' : '']">
                  {{ message }}
                </p>
              </div>

              <!-- Actions -->
              <div class="px-6 py-4 border-t border-border flex items-center justify-end gap-3">
                <!-- Cancel Button -->
                <button class="btn-outline rounded-lg px-4 py-2 font-semibold text-foreground"
                        @click="handleCancel">
                  {{ cancelText }}
                </button>

                <!-- Confirm Button -->
                <button :class="[
                          'rounded-lg px-4 py-2 font-semibold text-white',
                          isDangerous
                            ? 'bg-red-600 hover:bg-red-700'
                            : 'bg-primary hover:bg-primary/90',
                        ]"
                        @click="handleConfirm">
                  {{ confirmText }}
                </button>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
interface Props {
  isOpen: boolean
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
  isDangerous?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  confirmText: 'Confirm',
  cancelText: 'Cancel',
  isDangerous: false,
});

const emit = defineEmits<{
  confirm: []
  cancel: []
  close: []
}>();

const handleConfirm = () => {
  emit('confirm');
};

const handleCancel = () => {
  emit('cancel');
};

const handleBackdropClick = () => {
  emit('close');
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.scale-up-enter-active,
.scale-up-leave-active {
  transition: transform 0.3s ease;
}

.scale-up-enter-from,
.scale-up-leave-to {
  transform: scale(0.95);
}
</style>
